var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 20,
    viewBox: "0 0 31 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0582 19.0369C7.70172 15.3934 11.3452 11.7499 14.9886 8.1065C15.2776 7.8175 15.8556 7.8175 16.1447 8.1065L27.0751 19.0369C27.393 19.3548 27.9132 19.3549 28.2311 19.0369L30.5282 16.7399C30.8462 16.4219 30.8462 15.9018 30.5282 15.5838L16.1447 1.20035C15.8267 0.882434 15.3066 0.882434 14.9886 1.20035L0.605154 15.5838C0.287174 15.9018 0.287174 16.422 0.605154 16.7399L2.90213 19.0369C3.21999 19.3547 3.74028 19.3549 4.0582 19.0369Z",
    fill: "#B1C9EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4703 15.584L16.1443 9.25797C15.8263 8.94005 15.3061 8.94005 14.9882 9.25797L8.66219 15.584C8.34427 15.9019 8.34427 16.4221 8.66219 16.7401L10.9592 19.037C11.2771 19.355 11.7973 19.355 12.1153 19.037C13.0729 18.0794 14.0306 17.1218 14.9882 16.1642C15.2772 15.8752 15.8552 15.8752 16.1443 16.1642L19.0172 19.037C19.3351 19.355 19.8553 19.355 20.1732 19.037L22.4702 16.7401C22.7882 16.4221 22.7882 15.9019 22.4702 15.584H22.4703Z",
    fill: "#316DB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d6b430108aa4a250ac7174eb919ebe38.svg";
export { ForwardRef as ReactComponent };